import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withSize} from 'react-sizeme';
import useSWR from 'swr';
import pluralize from 'pluralize';
import moment from 'moment';
import axiosInstance from '../../../shared/utils/axios';
import {formatter} from '../../../shared/utils/utils';
import {Column, DescriptiveText, LoadingSpinner, TextInput, SectionTitle, Columnizer} from '../../../shared';
import debug from 'debug';

const log = debug('circleblack:investor:PortfolioInfo');

const PortfolioInfo = ({containerID, session, size}) => {
  const {data: portfolio, error: portfolioError} = useSWR(`/containers/${containerID}`);
  const {data: advisors, error: advisorsError} = useSWR('/user/advisors');
  const {data: clientsNumber, error: clientsNumberError} = useSWR(`/containers/${containerID}/clients/actual`, url => axiosInstance.get(url)
    .then(res => res.data.length));

  log('portfolioInfo');

  const [error, setError] = useState();

  useEffect(() => {
    if (portfolioError?.response?.data || clientsNumberError?.response.data || advisorsError?.response?.data) {
      setError(portfolioError?.response?.data.error || clientsNumberError?.response?.data.error || advisorsError?.response?.data.error);
    }
  }, [portfolioError, clientsNumberError, advisorsError]);

  if (!portfolio || !clientsNumber || !advisors) {
    if (error) {
      return <DescriptiveText>{error.msg || 'Failed to load data from API.'}</DescriptiveText>;
    }
    return <LoadingSpinner/>;
  }

  return <div>
    <Columnizer alignItems='top' height='auto' justifySubRow={'left'} itemWidth={size.width >= 700 ? 300 : 150} itemGrow={true} maxWidth={'100%'} wrap={true} margin={'10px 0 20px 0'}>
      <Column alignItems={'left'} width={'100%'} margin={'10px 0 10px 0'}>
        <TextInput type={'text'}
                   placeholder={''}
                   dataPoint={{name: 'name', value: session.profile.name}}
                   title={'Household Name'}
                   readOnly={true}/>
      </Column>
      <Column alignItems={'left'} width={'100%'} margin={'10px 0 10px 0'}>
        <DescriptiveText font={'ProximaSemibold'}
                         fontSize={'20px'}
                         alignment={'left'}
                         margin={'5px 5px 0'}>
          {formatter('currency')(portfolio.amount)}
        </DescriptiveText>
        <DescriptiveText font={'ProximaLight'}
                         fontSize={'10px'}
                         alignment={'left'}>
          Last Updated: {moment(portfolio.updatedAt).format('M/D/YY')}
        </DescriptiveText>
      </Column>
      <Column alignItems={'left'} width={'100%'} margin={'10px 0 10px 0'}>
        <TextInput type={'text'}
                   placeholder={''}
                   dataPoint={{name: 'clients', value: clientsNumber}}
                   title={'# of Clients'}
                   readOnly={true}/>
      </Column>
      <Column alignItems={'left'} width={'100%'} margin={'10px 0 10px 0'}>
        <TextInput type={'text'}
                   placeholder={''}
                   dataPoint={{name: 'holdings', value: portfolio.counts.positions.total}}
                   title={'# of Holdings'}
                   readOnly={true}/>
      </Column>
      <Column alignItems={'left'} width={'100%'} margin={'10px 0 10px 0'}>
        <TextInput type={'text'}
                   placeholder={''}
                   dataPoint={{name: 'accounts', value: portfolio.counts.accounts.total}}
                   title={'# of Accounts'}
                   readOnly={true}/>
      </Column>
    </Columnizer>
    <SectionTitle title={pluralize('Advisor', advisors.length) + ':'}/>
    <Columnizer alignItems='top' height='auto' justifySubRow={'left'} itemWidth={300} maxWidth={'100%'} wrap={true}>
      {advisors.map(advisor => <Column key={advisor.id} alignItems={'left'} width={'100%'}>
        <DescriptiveText font={'ProximaSemibold'}
                         fontSize={'16px'}
                         alignment={'left'}
                         margin={'12px 5px 5px'}>
          {advisor.firstName + ' ' + advisor.lastName}
        </DescriptiveText>
        <DescriptiveText font={'ProximaRegular'}
                         fontSize={'14px'}
                         alignment={'left'}
                         margin={'0px 5px 5px'}>
          {advisor.email}
        </DescriptiveText>
      </Column>)}
    </Columnizer>
  </div>;
};

const mapStateToProps = state => ({
  session: state.session,
});

export default connect(mapStateToProps, null)(withSize()(PortfolioInfo));

PortfolioInfo.propTypes = {
  /**
   * The container ID
   */
  containerID: PropTypes.number.isRequired,
  session: PropTypes.object.isRequired,
  /**
   * SizeMe size
   */
  size: PropTypes.shape({
    width: PropTypes.number,
  }),
};
